const PREFIX = '@@DECISION';

export const FETCHED_DECISIONS = `${PREFIX}/FETCHED_DECISIONS`;
export const LOADING_DECISIONS = `${PREFIX}/LOADING_DECISIONS`;
export const START_LOADING_DECISIONS = `${PREFIX}/START_LOADING_DECISIONS`;
export const END_LOADING_DECISIONS = `${PREFIX}/END_LOADING_DECISIONS`;
export const UPDATE_DECISION = `${PREFIX}/UPDATE_DECISION`;
export const DELETE_DECISION = `${PREFIX}/DELETE_DECISION`;
export const CREATE_DECISION = `${PREFIX}/CREATE_DECISION`;
